import { breakpoints, fonts } from 'style'
import styled from 'styled-components'

export const BooksListContainer = styled.div`
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: auto;

  .books-list {
    width: 100%;
    display: flex;
    align-items: center;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    box-shadow: none;
    border: none;
  }

  .bl-select {
    text-decoration: none;
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    font-family: ${fonts.main};
    border: none;
    border-bottom: solid 2px #000082;

    .ant-select-selector {
      border: none;
    }
  }

  h4 {
    font-family: ${fonts.main};
    border-bottom: solid 2px #000082;
    margin-bottom: -1px;
    padding-bottom: 3px;
  }

  @media (max-width: ${breakpoints.sm}px) {
    .books-list {
      width: 100%;
    }
  }
`
